import { useTheme } from 'styled-components';

import Text from '../../../components/Text';

// The hint beside LibrariesSelect on every chart page. Selecting a kit there downloads it; only
// the option's (i) button opens the kit page, and the chart image is the same for every kit.
const KitSelectorHint = () => {
  const theme = useTheme();

  return (
    <Text
      color={theme.neutralTextWeak}
      fontSize={theme.fontSizes.xs}
      lineHeight={theme.lineHeights.xs}
    >
      Select a kit from the dropdown menu to download it, or select its (i) icon to open the kit
      page. <br />
      Follow the provided instructions to locate your plot and complete the installation process.
    </Text>
  );
};

export default KitSelectorHint;
